function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapes_svg__New_Gradient_Swatch_1",
  x1: 7426.04,
  y1: -1262.89,
  x2: 7735.51,
  y2: -1262.89,
  gradientTransform: "translate(-7422.94 1421.39)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#43e9cf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#14191e"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapes_svg__New_Gradient_Swatch_1-2",
  x1: 7735.51,
  y1: -1262.89,
  x2: 8044.98,
  y2: -1262.89,
  xlinkHref: "#shapes_svg__New_Gradient_Swatch_1"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapes_svg__New_Gradient_Swatch_1-3",
  x1: 7426.04,
  y1: -953.42,
  x2: 7735.51,
  y2: -953.42,
  xlinkHref: "#shapes_svg__New_Gradient_Swatch_1"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapes_svg__New_Gradient_Swatch_1-4",
  x1: 7735.51,
  y1: -953.86,
  x2: 8044.98,
  y2: -953.86,
  xlinkHref: "#shapes_svg__New_Gradient_Swatch_1"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapes_svg__New_Gradient_Swatch_1-5",
  x1: 8044.98,
  y1: -1262.89,
  x2: 8354.45,
  y2: -1262.89,
  xlinkHref: "#shapes_svg__New_Gradient_Swatch_1"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapes_svg__New_Gradient_Swatch_1-6",
  x1: 7735.51,
  y1: -643.93,
  x2: 8044.98,
  y2: -643.93,
  xlinkHref: "#shapes_svg__New_Gradient_Swatch_1"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapes_svg__New_Gradient_Swatch_1-7",
  x1: 8199.72,
  y1: -180.07,
  x2: 8199.72,
  y2: -489.54,
  xlinkHref: "#shapes_svg__New_Gradient_Swatch_1"
}), /*#__PURE__*/React.createElement("style", null, ".shapes_svg__cls-7{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:6.19px}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "shapes_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "shapes_svg__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#shapes_svg__New_Gradient_Swatch_1)",
  d: "M312.57 313.24H3.1L312.57 3.77v309.47z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shapes_svg__New_Gradient_Swatch_1-2)",
  d: "M312.57 3.77h309.47L312.57 313.24V3.77z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shapes_svg__New_Gradient_Swatch_1-3)",
  d: "M312.57 313.24v309.47L3.1 313.24h309.47z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shapes_svg__New_Gradient_Swatch_1-4)",
  d: "M312.57 622.27V312.8l309.47 309.47H312.57z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 776.77,
  cy: 158.5,
  r: 154.74,
  fill: "url(#shapes_svg__New_Gradient_Swatch_1-5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M622 622.73V932.2H312.57c0-170.93 138.55-309.47 309.43-309.47z",
  fill: "url(#shapes_svg__New_Gradient_Swatch_1-6)"
}), /*#__PURE__*/React.createElement("path", {
  className: "shapes_svg__cls-7",
  d: "M622 313h309.51v309.5C760.59 622.5 622 484 622 313z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shapes_svg__New_Gradient_Swatch_1-7)",
  d: "M622.04 931.86h309.47l-309.47 309.47V931.86z"
}), /*#__PURE__*/React.createElement("path", {
  className: "shapes_svg__cls-7",
  d: "M622.04 3.54h309.47v309.47H622.04zm0 619.17h309.47v309.47H622.04zm309.47 0h309.47v309.47H931.51z"
}), /*#__PURE__*/React.createElement("path", {
  className: "shapes_svg__cls-7",
  d: "M931.51 622.71h309.47v309.47H931.51z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "shapes_svg__cls-7",
  cx: 312.56,
  cy: 622.7,
  r: 309.47
}), /*#__PURE__*/React.createElement("path", {
  className: "shapes_svg__cls-7",
  d: "M931.51 313.45V3.1l309.47 309.47-309.47.88z"
}), /*#__PURE__*/React.createElement("path", {
  className: "shapes_svg__cls-7",
  d: "M1241 313H931.51v309.5C1102.43 622.5 1241 484 1241 313z"
})));

function SvgShapes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1244.07 1241.33"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,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";
export { SvgShapes as ReactComponent };